(function () {
  const WRAPPER_SELECTOR = '.trial_participation';
  const PERIOD_HIDDEN_ATTR = 'data-bentatsu-period-hidden';
  const ORIGINAL_DISPLAY_ATTR = 'data-bentatsu-original-display';

  /**
   * 対応形式：
   * 2026-07-03
   * 2026-07-03T17:00
   * 2026-07-03 17:00
   * 2026/07/03 17:00
   * 2026年07月03日 17:00
   *
   * mode = start の場合、日付だけなら 00:00:00
   * mode = end の場合、日付だけなら 23:59:59
   */
  const parseDateTime = (value, mode = 'end') => {
    if (!value) return null;

    const decoded = decodeURIComponent(String(value))
      .replace(/\+/g, ' ')
      .replace(/年|月/g, '-')
      .replace(/日/g, '')
      .trim();

    const match = decoded.match(
      /^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:[T\s_](\d{1,2})(?::|-)?(\d{2})(?::?(\d{2}))?)?$/
    );

    if (!match) return null;

    const year = Number(match[1]);
    const month = Number(match[2]) - 1;
    const day = Number(match[3]);
    const hasTime = match[4] !== undefined;

    const hour = hasTime ? Number(match[4]) : mode === 'start' ? 0 : 23;
    const minute = hasTime ? Number(match[5]) : mode === 'start' ? 0 : 59;
    const second = hasTime
      ? Number(match[6] || 0)
      : mode === 'start'
        ? 0
        : 59;
    const millisecond = hasTime ? 0 : mode === 'start' ? 0 : 999;

    return new Date(year, month, day, hour, minute, second, millisecond);
  };

  const getCommentNodes = (root) => {
    const comments = [];
    const iterator = document.createNodeIterator(
      root,
      NodeFilter.SHOW_COMMENT,
      null,
      false
    );

    let node;
    while ((node = iterator.nextNode())) {
      comments.push(node);
    }

    return comments;
  };

  const removeElements = (elements) => {
    elements.forEach((el) => {
      if (el && el.parentNode) {
        el.remove();
      }
    });
  };

  const getTargetSection = (element) => {
    if (!element) return null;

    return (
      element.closest('.shopify-section') ||
      element.closest('[id^="shopify-section-"]') ||
      element.closest('section') ||
      element.closest(WRAPPER_SELECTOR) ||
      element.parentElement
    );
  };

  const setSectionVisible = (section, isVisible) => {
    if (!section) return;

    if (!section.hasAttribute(ORIGINAL_DISPLAY_ATTR)) {
      section.setAttribute(ORIGINAL_DISPLAY_ATTR, section.style.display || '');
    }

    if (isVisible) {
      section.style.display = section.getAttribute(ORIGINAL_DISPLAY_ATTR) || '';
      section.removeAttribute('hidden');
      section.removeAttribute(PERIOD_HIDDEN_ATTR);
    } else {
      section.style.display = 'none';
      section.setAttribute('hidden', 'hidden');
      section.setAttribute(PERIOD_HIDDEN_ATTR, 'true');
    }
  };

  /**
   * 追加セクションの表示期間制御
   *
   * 推奨形式：
   * <div
   *   data-section-start="2026-07-01T00:00"
   *   data-section-end="2026-07-06T16:30"
   *   style="display:none;"
   * ></div>
   *
   * コメント形式も対応：
   * <!-- section-start=2026-07-01T00:00 -->
   * <!-- section-end=2026-07-06T16:30 -->
   *
   * または1行でも可：
   * <!-- section-start=2026-07-01T00:00 section-end=2026-07-06T16:30 -->
   */
  const applySectionPeriodControls = () => {
    const now = new Date();
    const controls = new Map();

    const ensureControl = (section) => {
      if (!section) return null;

      if (!controls.has(section)) {
        controls.set(section, {
          start: null,
          end: null
        });
      }

      return controls.get(section);
    };

    // data属性形式に対応
    document
      .querySelectorAll(
        '[data-section-start], [data-section-end], [data-show-start], [data-show-end]'
      )
      .forEach((marker) => {
        const section = getTargetSection(marker);
        const control = ensureControl(section);
        if (!control) return;

        const start =
          marker.getAttribute('data-section-start') ||
          marker.getAttribute('data-show-start');

        const end =
          marker.getAttribute('data-section-end') ||
          marker.getAttribute('data-show-end');

        if (start) control.start = start.trim();
        if (end) control.end = end.trim();
      });

    // コメント形式に対応
    getCommentNodes(document.body).forEach((node) => {
      const text = node.nodeValue.trim();

      const startMatch = text.match(
        /(?:section-start|section_start|show-start|show_start)\s*=\s*([^\s,、]+)/
      );

      const endMatch = text.match(
        /(?:section-end|section_end|hide-end|hide_end)\s*=\s*([^\s,、]+)/
      );

      if (!startMatch && !endMatch) return;

      const section = getTargetSection(node.parentElement);
      const control = ensureControl(section);
      if (!control) return;

      if (startMatch) control.start = startMatch[1].trim();
      if (endMatch) control.end = endMatch[1].trim();
    });

    controls.forEach((control, section) => {
      const startAt = control.start
        ? parseDateTime(control.start, 'start')
        : null;

      const endAt = control.end
        ? parseDateTime(control.end, 'end')
        : null;

      const isAfterStart = !startAt || now >= startAt;
      const isBeforeEnd = !endAt || now < endAt;

      setSectionVisible(section, isAfterStart && isBeforeEnd);
    });
  };

  /**
   * 既存のお試し参加セクション制御
   *
   * 既存形式：
   * <!-- 2026-07-03~start -->
   * ...
   * <!-- 2026-07-03~end -->
   *
   * 時間指定形式：
   * <!-- 2026-07-03T17:00~start -->
   * ...
   * <!-- 2026-07-03T17:00~end -->
   *
   * この処理は「1つの trial_participation 内で次の1件だけ表示する」従来仕様用。
   * 複数のお試し参加ブロックを同時表示したい追加セクションでは、
   * data-section-start / data-section-end だけを使うのがおすすめ。
   */
  const processTrialParticipation = (wrapper) => {
    const now = new Date();
    const container = wrapper.querySelector('.cnt_inner') || wrapper;
    const comments = getCommentNodes(container);
    const sections = [];

    comments.forEach((node) => {
      const text = node.nodeValue.trim();
      const match = text.match(/^(.+?)~start$/);
      if (!match) return;

      const dateKey = match[1].trim();
      const endAt = parseDateTime(dateKey, 'end');
      if (!endAt) return;

      let startEl = node.parentElement;
      if (!startEl) return;

      // 直前に日付見出し .date がある場合は、そこからまとめて制御対象にする
      if (
        startEl.previousElementSibling &&
        startEl.previousElementSibling.classList.contains('date')
      ) {
        startEl = startEl.previousElementSibling;
      }

      const elements = [startEl];
      let next = startEl.nextElementSibling;
      const endText = `${dateKey}~end`;

      while (next) {
        elements.push(next);

        if (next.innerHTML.includes(endText)) {
          break;
        }

        // 次の start にぶつかった場合は、そこから先は別日程扱い
        if (next.innerHTML.includes('~start')) {
          elements.pop();
          break;
        }

        next = next.nextElementSibling;
      }

      sections.push({
        endAt,
        elements
      });
    });

    if (!sections.length) return;

    sections.sort((a, b) => a.endAt - b.endAt);

    let foundNext = false;

    sections.forEach((section) => {
      if (now >= section.endAt) {
        removeElements(section.elements);
        return;
      }

      if (!foundNext) {
        foundNext = true;
        return;
      }

      removeElements(section.elements);
    });

    // 未来の日程がない場合
    if (!foundNext) {
      // セクションに hide_when_ended クラス、または data-hide-when-ended="true" があればセクションごと非表示
      if (
        wrapper.classList.contains('hide_when_ended') ||
        wrapper.dataset.hideWhenEnded === 'true'
      ) {
        wrapper.remove();
        return;
      }

      // 従来仕様：次回日程調整中を表示
      if (!container.querySelector('.date')) {
        const newDateP = document.createElement('p');
        newDateP.className = 'date';
        newDateP.textContent = '次回日程調整中';
        container.prepend(newDateP);
      }
    }
  };

  const run = () => {
    // 追加セクションの表示開始・終了制御
    applySectionPeriodControls();

    // 非表示期間中のセクション内は、従来処理を走らせない
    document.querySelectorAll(WRAPPER_SELECTOR).forEach((wrapper) => {
      if (wrapper.closest(`[${PERIOD_HIDDEN_ATTR}="true"]`)) return;
      processTrialParticipation(wrapper);
    });
  };

  document.addEventListener('DOMContentLoaded', run);

  // Shopifyテーマエディタでセクションが再描画・選択された時にも動かす
  document.addEventListener('shopify:section:load', () => {
    setTimeout(run, 100);
  });

  document.addEventListener('shopify:section:select', () => {
    setTimeout(run, 100);
  });

  // 描画遅延対策
  setTimeout(run, 300);
  setTimeout(run, 1000);
  setTimeout(run, 2000);
})();